/// <amd-module name="Artifacts/Nuget/NugetProtocol" />
import {
  createBadgeCommand,
  createDeleteCommand,
  createDownloadCommand,
  createGetLinkCommand,
  createListStatusCommand,
  createPermanentDeleteCommand,
  createPromoteCommand,
  createRestoreCommand,
  createUpstreamOverrideCommand,
} from "Artifacts/Nuget/commands";
import { logoContributionId } from "Artifacts/Nuget/components/Logo";
import { NugetAttributes } from "Artifacts/Nuget/components/NugetPackageAttributes";
import { NugetOverview } from "Artifacts/Nuget/components/NugetPackageOverview";
import { NugetModule } from "Artifacts/Nuget/redux";
import { IFeedNuGetDataService } from "Artifacts/Nuget/services/NuGetDataService";
import { Protocol } from "Artifacts/Root/Constants";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { UpstreamVersionVisibility } from "Artifacts/Root/types/PackagingShared";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export class NugetProtocol implements IProtocol {
  public readonly id = Protocol.Nuget;
  public readonly name = "NuGet";
  public readonly statusUrl = "https://status.nuget.org/";

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    const commands = [
      createDownloadCommand(pageContext, versions, feed),
      createPromoteCommand(pageContext, versions),
      createListStatusCommand(pageContext, versions, feed),
      createDeleteCommand(pageContext, versions, feed),
      createPermanentDeleteCommand(pageContext, versions, feed),
      createRestoreCommand(pageContext, versions),
      createBadgeCommand(pageContext, versions, feed),
      createUpstreamOverrideCommand(pageContext),
      createGetLinkCommand(pageContext, versions, feed),
    ].filter((x) => x !== undefined) as ICommand[];

    return commands;
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return NugetOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return NugetAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return NugetModule;
  }

  public async getUpstreamOverrideStatus(
    pageContext: IVssPageContext,
    packageName: string,
    feed?: IFeed,
  ): Promise<boolean> {
    if (!feed) {
      return false;
    }
    const nugetDataService = pageContext.getService<IFeedNuGetDataService>("IFeedNuGetDataService");
    const overrideBehavior = await nugetDataService.getUpstreamingBehavior(
      feed?.id,
      packageName,
      feed?.project?.id,
    );
    return (
      overrideBehavior?.versionsFromExternalUpstreams ===
      UpstreamVersionVisibility.AllowExternalVersions
    );
  }

  public getUpstreamingProperties(_pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: true,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: true,
      isAadUpstreamsSupported: true,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }
}

ProtocolService.registerProtocol(new NugetProtocol());
